export const BANK_REDIRECT_MOBILE = {
  TITLE: 'Continue on mobile',
  TEXT: 'Please approve the payment in your bank.',
  LINK_TEXT: 'Lost the link?',
  BACK_LINK_TEXT: 'Go Back',
};
